import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";

const pointColors: any = {
  "20": "#7BC96F",
  "40": "#F5C242",
  "60": "#3B82F6",
  "80": "#E5E7EB",
};

export const EdgePinchVisual = ({
  procedureData,
}: any) => {

  const edgePinch =
    procedureData?.edge_pinch || {};

  const locations =
    edgePinch?.locations || [];

  const locationMap: any = {};

  locations.forEach((loc: any) => {
    locationMap[loc.location] = loc;
  });

  return (
    <Card style={{
      maxWidth: 420,
      margin: "0 auto",
    }}>

      <CardContent>



        <Box
          position="relative"
          height={500}
          width={300}
          borderRadius={12}
          style={{
            background:
              "linear-gradient(180deg,#1fa4b5,#178d9d)",
            border: "6px solid #D94132",
            overflow: "hidden",
          }}
        >

          <Box
            position="absolute"
            top={8}
            left="50%"
            style={{
              transform: "translateX(-50%)",
              color: "#111827",
              fontWeight: 900,
              fontSize: 9,
              letterSpacing: 1,
            }}
          >
            MODULE TOP
          </Box>
          {/* CENTER GUIDE LINES */}
          <Box
            position="absolute"
            top="50%"
            left={0}
            right={0}
            borderTop="2px dashed rgba(255,255,255,0.4)"
          />

          <Box
            position="absolute"
            left="50%"
            top={0}
            bottom={0}
            borderLeft="2px dashed rgba(255,255,255,0.4)"
          />

          {/* J BOXES */}
          <Box
            position="absolute"
            top="50%"
            left="50%"
            style={{
              transform: "translate(-50%, -50%)",
              display: "flex",
              alignItems: "center",
              gap: 50,
            }}
          >
            {[1, 2, 3].map((item) => (
              <Box
                key={item}
                style={{
                  background: "#0B4EA2",
                  color: "white",
                  // padding: "4px 14px",
                  borderRadius: 4,
                  fontWeight: 700,
                  fontSize: 12,
                  minWidth: 50,
                  textAlign: "center",
                }}
              >
                J-box
              </Box>
            ))}
          </Box>

          {/* LOCATION 1 */}
          <Box
            position="absolute"
            top={10}
            left={10}
          >
            <Typography
              style={{
                color: "white",
                // fontWeight: 700,
                fontSize: 14,
                marginBottom: 8,
              }}
            >
              Location 1
            </Typography>

            {locationMap["L1"] &&
              Object.entries(
                locationMap["L1"].thickness || {}
              ).map(([key, value]: any) => (

                <Box
                  key={key}
                  display="flex"
                  alignItems="center"
                  mb={1}
                >
                  <Box
                    mr={1}
                    width={12}
                    height={12}

                    style={{
                      background: pointColors[key],
                      border: "1.5px solid black",
                      transform: "rotate(45deg)",
                    }}
                  />

                  <Typography
                    style={{
                      width: 40,
                      color: "black",
                      fontSize: 10,
                      marginRight: 4,
                    }}
                  >
                    {
                      locationMap["L1"]
                        ?.outside_edge?.[key]
                    } mm
                  </Typography>

                  <Box
                    style={{
                      background: "white",
                      borderRadius: 20,
                      // padding: "4px 14px",
                      fontSize: 10,
                      minWidth: 40,
                      textAlign: "center",

                    }}
                  >
                    {value}
                  </Box>
                </Box>
              ))}
          </Box>

          {/* LOCATION 2 */}
          <Box
            position="absolute"
            top={10}
            right={10}
          >
            <Typography
              style={{
                color: "white",
                // fontWeight: 700,
                marginBottom: 8,
                fontSize: 14,
                textAlign: "right",
              }}
            >
              Location 2
            </Typography>

            {locationMap["L2"] &&
              Object.entries(
                locationMap["L2"].thickness || {}
              ).map(([key, value]: any) => (

                <Box
                  key={key}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  mb={1}
                >
                  <Box
                    style={{
                      background: "white",
                      borderRadius: 20,
                      // padding: "4px 14px",
                      fontSize: 10,
                      minWidth: 40,
                      textAlign: "center",
                      marginRight: 5
                    }}
                  >
                    {value}
                  </Box>

                  <Typography
                    style={{
                      width: 40,
                      color: "black",
                      fontSize: 10,
                    }}
                  >
                    {
                      locationMap["L2"]
                        ?.outside_edge?.[key]
                    } mm
                  </Typography>

                  <Box
                    ml={1}
                    width={12}
                    height={12}

                    style={{
                      background: pointColors[key],
                      border: "1.5px solid black",
                      transform: "rotate(45deg)",
                    }}
                  />
                </Box>
              ))}
          </Box>

          {/* LOCATION 3 */}
          <Box
            position="absolute"
            bottom={10}
            left={10}
          >
            <Typography
              style={{
                color: "white",
                // fontWeight: 700,
                fontSize: 14,
                marginBottom: 8,
              }}
            >
              Location 3
            </Typography>

            {[...Object.entries(
              locationMap["L3"]?.thickness || {}
            )]
              .reverse()
              .map(([key, value]: any) => (

                <Box
                  key={key}
                  display="flex"
                  alignItems="center"
                  mb={1}
                >
                  <Box
                    mr={1}
                    width={12}
                    height={12}

                    style={{
                      background: pointColors[key],
                      border: "1.5px solid black",
                      transform: "rotate(45deg)",
                    }}
                  />

                  <Typography
                    style={{
                      width: 40,
                      color: "black",
                      fontSize: 10,
                    }}
                  >
                    {
                      locationMap["L3"]
                        ?.outside_edge?.[key]
                    } mm
                  </Typography>

                  <Box
                    style={{
                      background: "white",
                      borderRadius: 20,
                      // padding: "4px 14px",
                      fontSize: 10,
                      minWidth: 40,
                      textAlign: "center",
                    }}
                  >
                    {value}
                  </Box>
                </Box>
              ))}
          </Box>

          {/* LOCATION 4 */}
          <Box
            position="absolute"
            bottom={10}
            right={10}
          >
            <Typography
              style={{
                color: "white",
                // fontWeight: 700,
                fontSize: 14,
                marginBottom: 8,
                textAlign: "right",
              }}
            >
              Location 4
            </Typography>

            {[...Object.entries(
              locationMap["L4"]?.thickness || {}
            )]
              .reverse()
              .map(([key, value]: any) => (

                <Box
                  key={key}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  mb={1}
                >
                  <Box
                    style={{
                      background: "white",
                      borderRadius: 20,
                      // padding: "4px 14px",
                      fontSize: 10,
                      minWidth: 40,
                      textAlign: "center",
                      marginRight: 5
                    }}
                  >
                    {value}
                  </Box>

                  <Typography
                    style={{
                      width: 40,
                      color: "black",
                      fontSize: 10,
                    }}
                  >
                    {
                      locationMap["L4"]
                        ?.outside_edge?.[key]
                    } mm
                  </Typography>

                  <Box
                    ml={1}
                    width={12}
                    height={12}

                    style={{
                      background: pointColors[key],
                      border: "1.5px solid black",
                      transform: "rotate(45deg)",
                    }}
                  />
                </Box>
              ))}
          </Box>

        </Box>
        <Typography
          style={{
            marginTop: 12,
            fontSize: 12,
            color: "#4B5563",
            lineHeight: 1.5,
          }}
        >
          Figure shows the front view of the module. Jbox is added
          as a reference to visualize the center line. The
          measurements are taken while keeping the module facing
          up on a table.
        </Typography>

      </CardContent>

    </Card>
  );
};